/**
 * Save cookie in session storage then delete them
 */
export default defineNuxtPlugin(() => {
  const origin = useCookie("origin");
  const out = useCookie("out");
  const redirect = useCookie("redirect");
  const access = useCookie("access");

  const sessionStorage = useSessionStorage();

  if (origin.value) {
    sessionStorage.set("origin", origin.value);
    origin.value = null;
  }
  if (out.value) {
    sessionStorage.set("out", out.value);
    out.value = null;
  }
  if (redirect.value) {
    sessionStorage.set("redirect", redirect.value);
    redirect.value = null;
  }
  if (access.value) {
    sessionStorage.set("access", access.value);
    access.value = null;
  }
});
